import React from 'react'
import Widget from 'widgets/Widget'
import { Translation, Translator } from '@morningtrain/react-translations'
import { Collection, ForEachModel } from '@morningtrain/react-resources'
import SmartviewTextGroup from 'widgets/smartviews/partials/SmartviewTextGroup'
import SmartviewText from 'widgets/smartviews/partials/SmartviewText'
import { Can } from '@morningtrain/react-auth'
import Permissions from 'services/Permissions'
import * as UI from 'ui'
import * as Displays from 'support/displays'
import ForecastAdjuster from 'widgets/dashboard/partials/ForecastAdjuster'
import ForecastDepartmentWageRatio from 'widgets/dashboard/partials/ForecastDepartmentWageRatio'
import WeekDaySelector from "widgets/controls/WeekDaySelector";
import useActiveScheduleWeekday from "support/hooks/use-active-schedule-weekday";
import * as Filters from "support/filters";
import SmartviewContentSeparator from "widgets/smartviews/partials/SmartviewContentSeparator";
import upperFirst from "lodash/upperFirst";
import moment from "moment";

export default function ForecastSummaryDashboardWidget () {
  let [activeScheduleWeekday, setActiveScheduleWeekday] = useActiveScheduleWeekday()
  let date = moment();
  let currentDay = date.day();
  activeScheduleWeekday = (currentDay >= activeScheduleWeekday && currentDay !== 0 && activeScheduleWeekday !== 0)  ? (currentDay + 1) : activeScheduleWeekday;

  let translatedDay = 'generic.weekdays.normal.' + date.day(activeScheduleWeekday).format("dddd");
  return (
    <Can permission={Permissions.SHIFTS_ADJUST_FORECAST}>
      <Can permission='api.dashboard.forecast_summary'>
        <Widget>
          <Translator namespace='dashboard.forecast_summary'>
            <SmartviewContentSeparator className='mt-5 mb-6' />
            <Collection resourceName='dashboard' operationName='historical_forecast' >
              <Filters.StaticFilter name='day' value={activeScheduleWeekday} />
              <ForEachModel>
                <Collection resourceName='dashboard' operationName='forecast_summary' >
                <Filters.StaticFilter name='day' value={activeScheduleWeekday} />
                <WeekDaySelector onSelect={(weekDay) => setActiveScheduleWeekday(weekDay)} activeWeekday={activeScheduleWeekday} />
                <SmartviewContentSeparator className='mt-5 mb-6' />

                <div className='flex items-center justify-between'>
                  <span className='text-xl font-medium'>{upperFirst(date.day(activeScheduleWeekday).format("dddd"))}</span>
                  <span className='text-xl font-medium'><Displays.Currency name='locked_budget_week' decimals={0} /></span>
                </div>
                <SmartviewContentSeparator className='mt-5 mb-6' />

                <SmartviewTextGroup highlight>
                <ForEachModel>
                    <SmartviewText>

                      <UI.SpaceBetween cla  ssName='py-3'>

                        <UI.Text weight='medium' color='black' size='base'>
                          <Displays.Text name='name' />
                        </UI.Text>

                        <ForecastAdjuster weekDay={activeScheduleWeekday}/>

                      </UI.SpaceBetween>

                      <UI.HorizontalList border>

                        <UI.WithSubtitle subtitle={(
                          <UI.Text weight='medium' size='xs'>
                            <Translation name='smartviews.schedule_period_summary.forecast' />
                          </UI.Text>
                        )}
                        >
                          <UI.Text weight='medium' color='black' size='xs' wrap={false}>
                            <Displays.Currency name='live_forecast' decimals={0} />
                          </UI.Text>
                        </UI.WithSubtitle>

                        <UI.WithSubtitle subtitle={(
                          <UI.Text weight='medium' size='xs'>
                            <Translation name='smartviews.schedule_period_summary.wage_ratio' />
                          </UI.Text>
                        )}
                        >
                          <UI.Text weight='medium' color='black' size='xs'>
                            <ForecastDepartmentWageRatio />
                          </UI.Text>
                        </UI.WithSubtitle>

                        <UI.WithSubtitle subtitle={(
                          <UI.Text weight='medium' size='xs'>
                            <Translation name='smartviews.schedule_period_summary.locked_budget' />
                          </UI.Text>
                        )}
                        >
                          <UI.Text weight='medium' color='black' size='xs' wrap={false}>
                            <Displays.Currency name='locked_forecast' decimals={0} />
                          </UI.Text>
                        </UI.WithSubtitle>

                      </UI.HorizontalList>

                    </SmartviewText>
                  </ForEachModel>
                </SmartviewTextGroup>
                </Collection>
                <SmartviewContentSeparator className='mt-5 mb-6' />

                <SmartviewText label={<Translation name='smartviews.schedule_period_summary.historical_forecast' />}>
                    <div className='flex justify-center'>
                      <UI.Text>
                        <Translation
                          name='generic.this_year'
                        />
                      </UI.Text>
                    </div>
                    <div className='flex justify-between'>
                      <UI.Text>
                        <Translation
                          name='smartviews.schedule_day_summary.weekday_week'
                          data={{ weekday: upperFirst(date.format('dddd')), week: date.week() - 4 }}
                        />
                      </UI.Text>
                      <Displays.Currency name='realised_revenue4' decimals={0} />
                    </div>
                    <div className='flex justify-between'>
                      <UI.Text>
                        <Translation
                          name='smartviews.schedule_day_summary.weekday_week'
                          data={{ weekday: upperFirst(date.format('dddd')), week: date.week() - 3 }}
                        />
                      </UI.Text>
                      <Displays.Currency name='realised_revenue3' decimals={0} />
                    </div>
                    <div className='flex justify-between'>
                      <UI.Text>
                        <Translation
                          name='smartviews.schedule_day_summary.weekday_week'
                          data={{ weekday: upperFirst(date.format('dddd')), week: date.week() - 2 }}
                        />
                      </UI.Text>
                      <Displays.Currency name='realised_revenue2' decimals={0} />
                    </div>
                    <div className='flex justify-between'>
                      <UI.Text>
                        <Translation
                          name='smartviews.schedule_day_summary.weekday_last_week_number'
                          data={{ weekday: upperFirst(date.format('dddd')), week: date.week() - 1 }}
                        />
                      </UI.Text>
                      <Displays.Currency name='realised_revenue1' decimals={0} />
                    </div><br/>
                    <div className='flex justify-center'>
                      <UI.Text>
                        <Translation
                          name='generic.last_year'
                        />
                      </UI.Text>
                    </div>
                    <div className='flex justify-between'>
                      <UI.Text>
                        <Translation
                          name='smartviews.schedule_day_summary.weekday_week'
                          data={{ weekday: upperFirst(date.format('dddd')), week: date.week() - 4 }}
                        />
                      </UI.Text>
                      <Displays.Currency name='realised_revenue_last_year_week4' decimals={0} />
                    </div>
                    <div className='flex justify-between'>
                      <UI.Text>
                        <Translation
                          name='smartviews.schedule_day_summary.weekday_week'
                          data={{ weekday: upperFirst(date.format('dddd')), week: date.week() - 3 }}
                        />
                      </UI.Text>
                      <Displays.Currency name='realised_revenue_last_year_week3' decimals={0} />
                    </div>
                    <div className='flex justify-between'>
                      <UI.Text>
                        <Translation
                          name='smartviews.schedule_day_summary.weekday_week'
                          data={{ weekday: upperFirst(date.format('dddd')), week: date.week() - 2 }}
                        />
                      </UI.Text>
                      <Displays.Currency name='realised_revenue_last_year_week2' decimals={0} />
                    </div>
                    <div className='flex justify-between'>
                      <UI.Text>
                        <Translation
                          name='smartviews.schedule_day_summary.weekday_week'
                          data={{ weekday: upperFirst(date.format('dddd')), week: date.week() - 1 }}
                        />
                      </UI.Text>
                      <Displays.Currency name='realised_revenue_last_year_week1' decimals={0} />
                    </div>
                    <div className='flex justify-between'>
                      <UI.Text>
                        <Translation
                          name='smartviews.schedule_day_summary.weekday_week'
                          data={{ weekday: upperFirst(date.format('dddd')), week: date.week()}}
                        />
                      </UI.Text>
                      <Displays.Currency name='realised_revenue_last_year' decimals={0} />
                    </div>
                  </SmartviewText>
              </ForEachModel>
            </Collection>
          </Translator>
        </Widget>
      </Can>
    </Can>
  )
}
